import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../../components/layout/Header';
import Sidebar from '../../components/layout/Sidebar';
import OfflineBanner from '../../components/ui/OfflineBanner';
import { startTour } from '../../lib/tour';

const DashboardLayout = () => {
    return (
        <div className="main-wrapper">
            <OfflineBanner />
            <Header />
            <Sidebar />
            <div className="page-wrapper">
                <div className="content container-fluid">
                    <Outlet />
                </div>
            </div>
            <button
                onClick={startTour}
                title="Recorrido guiado"
                style={{
                    position: 'fixed', bottom: 24, right: 24,
                    width: 48, height: 48, borderRadius: '50%',
                    background: '#0EA5A4', color: '#fff', border: 'none',
                    fontSize: 20, cursor: 'pointer', zIndex: 9998,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                }}
            >
                ?
            </button>
        </div>
    );
};

export default DashboardLayout;
